import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useDeleteOpportunities = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (deletedCount: number) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ itemIds }: { itemIds: string[] }) => {
			return userSession.webServiceHelper.callAsync<number>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: 'board/items/delete' }),
				'POST',
				{ itemIds }
			);
		},
		onError,
		onSuccess,
	});
};
